import React from "react";
import "./About.css"; // CSS file for styling

// Sample data for reviews
const reviews = [
  {
    id: 1,
    name: "Sarah A.",
    dp: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ-ZzZdzsYRre4OhFP0NY01nJ2oYtcm_S4k7A&s",
    reviewText: "An excellent service! Always on time and very professional. Made my Umrah experience so much easier.",
    rating: 5,
  },
  {
    id: 2,
    name: "Ahmed B.",
    dp: "https://i.pinimg.com/474x/7b/6c/3a/7b6c3a27d225459c251887f1c9da32b7.jpg",
    reviewText: "Great experience with Umrah Taxi Services! The drivers were friendly, and the vehicles were comfortable.",
    rating: 4,
  },
  {
    id: 3,
    name: "Fatima C.",
    dp: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSCBG_gzAWcMdtyBfBWLOELVku0_xFbrQklNQ&s",
    reviewText: "Highly recommend! Punctual, professional, and made the journey smooth. Thank you for the amazing service!",
    rating: 5,
  },
  {
    id: 4,
    name: "John D.",
    dp: "https://media.istockphoto.com/id/1388648617/photo/confident-caucasian-young-man-in-casual-denim-clothes-with-arms-crossed-looking-at-camera.jpg?s=612x612&w=0&k=20&c=YxctPklAOJMmy6Tolyvn45rJL3puk5RlKt39FO46ZeA=",
    reviewText: "The service was good, but the car could have been a bit cleaner. Overall, a satisfactory experience.",
    rating: 3,
  },
];

const WhoWeAre = () => {
  return (
    <>
      <div className="aboutheadingg">
        <div>
          <h1 className="headingg">Who We Are</h1>
        </div>
      </div>

      <div className="mission-section">
        <div className="mission-text">
          <div className="abc"> <h2>Our Mission</h2></div>
          <p>Welcome to <span>Umrah Taxi Services</span>, your premier choice for Umrah taxi services. With over three years of dedicated service in the industry, we specialize in providing reliable, comfortable, and efficient transportation for your sacred journey.</p>

          <p>At <span>Umrah Taxi Services</span>, we understand the significance of your Umrah pilgrimage and the importance of a smooth and hassle-free travel experience. Our fleet of well-maintained vehicles and professional drivers are committed to ensuring your journey is as seamless as possible. Whether you need transportation to the holy sites or between your accommodations, we offer a range of services designed to meet your specific needs.</p>
          <p>Our team is passionate about delivering exceptional service and making your pilgrimage as memorable and stress-free as possible. We take pride in our punctuality, professionalism, and attention to detail, which has helped us build a strong reputation in the community.</p>
          <p>With over three years of experience, we have honed our skills and expertise to offer top-notch service that exceeds expectations. We are dedicated to serving our clients with the utmost respect and care, ensuring that every trip is conducted with the highest level of comfort and safety.</p>
          <p>Thank you for choosing <span>Umrah Taxi Services</span> for your Umrah transportation needs. We look forward to serving you and contributing to the success of your sacred journey.</p>
        </div>
        <div className="mission-image">
          <img src="images/cta.jpg" alt="Comfortable Taxi" />
        </div>
      </div>

      {/* Reviews */}
      <div className="reviews-section">
        <h2>What Our Clients Say</h2>
        <div className="reviews-slider">
          {reviews.map((review) => (
            <div className="review-card" key={review.id}>
              <img className="dp" src={review.dp} alt={`${review.name}'s DP`} />
              <p className="name">{review.name}</p>
              <p className="review-text">{review.reviewText}</p>

              <div className="review-footer">
                <div className="stars">
                  {[...Array(5)].map((_, index) => (
                    <span
                      key={index}
                      className={`star ${index < review.rating ? "filled" : ""}`}
                    >
                      &#9733;
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default WhoWeAre;
